<template>
    <div>
        <el-cascader
            ref="elCascader"
            popper-class="ah-select-variable-state-item"
            v-model="cascaderVal"
            :options="options"
            :props="statementCascaderPorp"
            :placeholder="`${placeholder}`"
            :key="cascaderKey"
            no-data="no"
            :style="`width: ${width}px`"
            :clearable="!nonClearable"
            :filterable="true"
            :size="size"
            :collapse-tags="collapseTags"
            :disabled="disabled"
            @change="handleCascaderChange"
        >
            <template slot-scope="{ data }">
                <span>{{ data.iteM_NAM }}</span>
                <span v-if="data.grP_MEM && data.grP_MEM !== '' && data.grP_MEM !== null">
                    <span class="mem">{{ data.grP_MEM }}</span>
                </span>
            </template>
        </el-cascader>
        <el-button v-if="showRefresh" icon="el-icon-refresh" style="margin-left: 5px" :size="size" @click="refresh"></el-button>
        <avatar-tip v-if="!hideTip" label="想增加項目？">
            收支項目關係到所有財務分析的分類，請找財務長討論看看喔。
        </avatar-tip>
    </div>
</template>
<script>
import _ from 'lodash';
import AvatarTip from '@/components/ui/AvatarTip.vue';

export default {
    name: 'ah-select-variable-item',
    components: {
        AvatarTip,
    },
    props: {
        value: {
            Type: Number,
            default: null,
        },
        disabled: {
            Type: Boolean,
            default: false,
        },
        type: {
            Type: String,
            default: 'all',
        },
        enableType: {
            Type: Array,
            default() {
                return ['invoice', 'payout', 'cIn', 'cOut', 'cInElse', 'cOutElse'];
            },
        },
        systemOnlyList: {
            Type: Array,
            default: () => [],
        },
        enableNull: {
            Type: Boolean,
            default: false,
        },
        nullLabel: {
            Type: String,
            default: '不限收支項目',
        },
        showTip: {
            Type: Boolean,
            default: false,
        },
        showRefresh: {
            Type: Boolean,
            default: true,
        },
        showSystemDefault: {
            type: Boolean,
            default: false,
        },
        hideTip: {
            type: Boolean,
            default: false,
        },
        size: {
            type: String,
            default: null,
        },
        width: {
            type: Number,
            default: 400,
        },
        placeholder: {
            Type: String,
            default: '請選擇收支項目',
        },
        collapseTags: {
            type: Boolean,
            default: false,
        },
        keywords: {
            Type: Array,
            default: () => [],
        },
        multiple: Boolean,
        nonClearable: Boolean,
    },
    watch: {
        value(val) {
            if (!this.multiple) {
                this.cascaderVal = this.getHierarchyArrayFromLeafSno(val);
            }
        },
        statementOptionsForUi(val) {
            if (val) this.$emit('onLoaded', val);
        },
    },
    computed: {
        cascaderKey() {
            // 取選項物件前500文字作為，產生component key
            return JSON.stringify(this.options || null).substring(0, 500);
        },
        statementOptions() {
            return this.$store.getters['statement/statementOptions'];
        },
        statementOptionsForUi() {
            return this.$store.getters['statement/statementUiOptions'];
        },
        options() {
            let allOptions = [
                {
                    sno: 1,
                    iteM_NAM: '營業收入',
                    childSettings: this.getChildSettings('invoiceSettings'),
                    disabled: !this.enableType.includes('invoice'),
                },
                {
                    sno: 2,
                    iteM_NAM: '營業支出',
                    childSettings: this.getChildSettings('payoutSettings'),
                    disabled: !this.enableType.includes('payout'),
                },
                {
                    sno: 3,
                    iteM_NAM: '營業其他收入',
                    childSettings: this.getChildSettings('cInSettings'),
                    disabled: !this.enableType.includes('cIn'),
                },
                {
                    sno: 4,
                    iteM_NAM: '營業其他支出',
                    childSettings: this.getChildSettings('cOutSettings'),
                    disabled: !this.enableType.includes('cOut'),
                },
                {
                    sno: 5,
                    iteM_NAM: '財務資產收入',
                    childSettings: this.getChildSettings('cInElseSettings'),
                    disabled: !this.enableType.includes('cInElse'),
                },
                {
                    sno: 6,
                    iteM_NAM: '財務資產支出',
                    childSettings: this.getChildSettings('cOutElseSettings'),
                    disabled: !this.enableType.includes('cOutElse'),
                },
            ];

            if (this.enableNull) {
                allOptions.unshift({
                    sno: null,
                    iteM_NAM: this.nullLabel ? this.nullLabel : '不限收支項目',
                    childSettings: null,
                });
            }

            if (this.multiple) {
                allOptions = _.chain(allOptions)
                    .map((o) => ({
                        ...o,
                        sno: `0:${o.sno}`,
                        childSettings: _.map(o.childSettings, (x) => ({
                            ...x,
                            sno: `1:${x.sno}`,
                        })),
                    }))
                    .value();
            }

            return _.filter(allOptions, ['disabled', false]);
        },
        statementCascaderPorp() {
            return {
                value: 'sno',
                label: 'iteM_NAM',
                mem: 'grP_MEM',
                children: 'childSettings',
                multiple: this.multiple,
            };
        },
    },
    data() {
        return {
            cascaderVal: [null],
        };
    },
    mounted() {
        if (this.value) {
            const wait = this.statementOptions !== null ? 1 : 1500;
            setTimeout(() => {
                this.cascaderVal = this.getHierarchyArrayFromLeafSno(this.value);
            }, wait);
        }
    },
    methods: {
        getMirrorParentSnoBySno(sno) {
            const found = _.chain(this.options[5].childSettings)
                .flatMap((o) => o.childSettings)
                .find(['sno', sno])
                .value();

            return found.copySno;
        },
        handleCascaderChange() {
            this.$emit('change', this.getItem(this.cascaderVal[2]));

            if (this.multiple) {
                this.$emit(
                    'input',
                    _.map(this.cascaderVal, (o) => _.last(o)),
                );
                return;
            }

            const val = this.cascaderVal[this.cascaderVal.length - 1];
            if (val !== 0 && val !== null) {
                this.$emit('input', val);
            } else {
                this.$emit('input', null);
            }
        },
        refresh() {
            this.$store.dispatch('statement/updateStatementOptions');
        },
        getHierarchyArrayFromLeafSno(sno) {
            if (!sno) {
                return [null];
            }

            const states = this.statementOptions;

            // 第一層：(ex: 財務收支（非營業）)
            for (const type in states) {
                // 第二層 (ex:系統預設)
                for (let i = 0; i < states[type].length; i += 1) {
                    // 第三層 (ex: 匯費)
                    for (let j = 0; j < states[type][i].childSettings.length; j += 1) {
                        if (states[type][i].childSettings[j].sno == sno) {
                            let typeSno = 0;
                            if (type === 'invoiceSettings') {
                                typeSno = 1;
                            }
                            if (type === 'payoutSettings') {
                                typeSno = 2;
                            }
                            if (type === 'cInSettings') {
                                typeSno = 3;
                            }
                            if (type === 'cOutSettings') {
                                typeSno = 4;
                            }
                            if (type === 'cInElseSettings') {
                                typeSno = 5;
                            }
                            if (type === 'cOutElseSettings') {
                                typeSno = 6;
                            }

                            const lvl1Sno = states[type][i].sno;
                            const lvl2Sno = states[type][i].childSettings[j].sno;

                            return [typeSno, lvl1Sno, lvl2Sno];
                        }
                    }
                }
            }
            return [];
        },
        getItem(sno) {
            if (!sno) return {};
            const states = this.statementOptions;

            // eslint-disable-next-line no-restricted-syntax, guard-for-in
            for (const type in states) {
                for (let i = 0; i < states[type].length; i += 1) {
                    for (let j = 0; j < states[type][i].childSettings.length; j += 1) {
                        if (states[type][i].childSettings[j].sno === sno) {
                            return states[type][i].childSettings[j];
                        }
                    }
                }
            }
            return {};
        },
        getChildSettings(fieldName) {
            let returnValue;

            if (this.systemOnlyList.includes(fieldName)) returnValue = this.statementOptionsForUi[fieldName]?.filter((o) => o.iS_SYS);
            else if (this.showSystemDefault) returnValue = this.statementOptionsForUi[fieldName];
            else returnValue = this.statementOptionsForUi[fieldName]?.filter((o) => !o.iS_SYS);

            if (!this.keywords.length) return returnValue;

            // 關鍵字優先排序
            const HEAD = [];
            this.keywords.forEach((item) => {
                const NEW_FOUND = _.chain(returnValue)
                    .filter((o) => o.iteM_NAM.includes(item))
                    .difference(HEAD)
                    .value();
                HEAD.push(...NEW_FOUND);
            });
            return [...HEAD, ..._.difference(returnValue, HEAD)];
        },
        clear() {
            this.$refs.elCascader.$refs.panel.checkedValue = [];
            this.$refs.elCascader.$refs.panel.clearCheckedNodes();
            this.$refs.elCascader.$refs.panel.activePath = [];
            this.$refs.elCascader.$refs.panel.syncActivePath();
        },
    },
};
</script>
<style lang="scss">
.ah-select-variable-state-item {
    .mem {
        font-size: 9pt;
        color: #bbb;
        margin: 0 0 0 12px;

        &:before {
            content: "(";
        }
        &:after {
            content: ")";
        }
    }
}
</style>
